import { Link } from "react-router-dom";
import Malla1 from "../assets/Mallas imagen/marron.jpg";
import Malla2 from "../assets/Mallas imagen/azul.jpg";
import Malla3 from "../assets/Mallas imagen/violeta.jpeg";   // CAMBIO (posible)
import Malla4 from "../assets/Mallas imagen/verde.PNG";   // CAMBIO (posible)
import fondo1 from "../assets/Mallas imagen/fondomallamarron.png";
import { FaCreditCard } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";
import { useCarrito } from "../context/CarritoContext"; // ⬅️ NUEVO


export default function Hero() {
  // 👉 funciones de formato y cálculo
  const formatPrice = (n) =>
    Number(n).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const precioTransfer = (n) => Math.round(n * 0.85);

  const precio30Off = (n) => Math.floor((n * 0.70) / 100) * 100; // -30% redondeado a 100

  // 👉 productos
  const mallas = [
    { id: "boardshort-2", nombre: "The Ocean", precio: 75200, img: Malla2 },
    { id: "boardshort-3", nombre: "The Sundown", precio: 75200, img: Malla3 },
    { id: "boardshort-1", nombre: "The Sunset", precio: 75200, img: Malla1 },
    { id: "boardshort-4", nombre: "The Tropic", precio: 75200, img: Malla4 },
  ];

  // ⬅️ NUEVO: carrito (igual que en Productos)
  const { agregarAlCarrito, showAddBanner } = useCarrito();

  // ⬅️ NUEVO: handler comprar directo desde el listado (igual que en Productos)
  const handleComprarListado = (e, producto) => {
    // Evita que navegue al detalle (el botón está dentro de un <Link>)
    e.preventDefault();
    e.stopPropagation();

    const talle = "M"; // default desde listado
    const cantidad = 1;

    agregarAlCarrito(producto, talle);
    showAddBanner({ ...producto, talle, cantidad });
  };

  // ===== Flechas (solo mobile) =====
  const mobileTrackRef = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  useEffect(() => {
    const el = mobileTrackRef.current;
    if (!el) return;
    const update = () => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      const x = el.scrollLeft;
      setCanPrev(x > 2);
      setCanNext(x < maxScroll - 2);
    };
    const raf = requestAnimationFrame(update);
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      ro.disconnect();
    };
  }, []);

  const scrollByCard = (dir) => {
    const el = mobileTrackRef.current;
    if (!el) return;
    const amount = Math.round(el.clientWidth * 0.85) * (dir === "next" ? 1 : -1);
    el.scrollBy({ left: amount, behavior: "smooth" });
  };

  // ⏱️ Duración del scroll (ms)
  const SCROLL_DURATION = 1100;

  return (
    <>
      {/* Hero */}
      <section id="hero" className="relative w-full h-[85vh] md:h-[90vh] overflow-hidden">
        <img
          src={fondo1}
          alt="Fondo principal"
          className="absolute inset-0 w-full h-full object-cover object-[10%_center] md:object-[65%_75%]"
        />
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-tr from-black/45 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black/25 to-transparent" />
        </div>

        {/* Overlay de contraste y copy a la izquierda */}
        <div className="relative z-10 h-full">
          {/* Degradé sutil para legibilidad */}
          <div
            className="pointer-events-none absolute inset-y-0 left-0 w-[75%] md:w-[620px]
                       bg-gradient-to-r from-black/10 via-black/10 to-transparent"
          />
          {/* Bloque de copy */}
          <div className="absolute bottom-8 left-4 right-4 md:bottom-12 md:left-60 md:right-auto md:max-w-[620px] text-white">
            <div className="space-y-3 md:space-y-6">
              <span className="block text-[11px] md:text-xs nav-onepalm text-white/85">
                El alma no se detiene
              </span>
              <h1 className="title-onepalm text-2xl md:text-5xl leading-tight drop-shadow-[0_1px_2px_rgba(0,0,0,0.7)]">
                WetSoul
              </h1>
              <div className="h-px w-20 md:w-24 bg-white/75" />
              <p className="block text-[11px] md:text-xs nav-onepalm text-white/85">
                Buenos Aires · Boards
              </p>

              {/* CTA que navega a /productos (lo dejo igual) */}
              <div className="pt-1 md:pt-2">
                <Link
                  to="/productos"
                  aria-label="Comprar"
                  className="inline-flex items-center justify-center px-5 md:px-6 py-2 md:py-2.5
                             text-[10px] md:text-sm proba
                             bg-white border border-black text-black
                             hover:bg-white/10 hover:border-white transition-colors duration-200
                             focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
                >
                  Comprar
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Indicador scroll */}
        <button
          onClick={() => {
            const el = document.getElementById("productos");
            if (!el) return;
            const cs = getComputedStyle(el);
            const scrollMt = parseFloat(cs.getPropertyValue("scroll-margin-top")) || 0;
            const startY = window.scrollY || window.pageYOffset;
            const targetTop = el.getBoundingClientRect().top + startY - scrollMt;
            const distance = targetTop - startY;
            let startTime = null;
            const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
            const step = (ts) => {
              if (startTime === null) startTime = ts;
              const progress = Math.min((ts - startTime) / SCROLL_DURATION, 1);
              window.scrollTo(0, startY + distance * ease(progress));
              if (progress < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          }}
          aria-label="Ir a las mallas"
          className="absolute bottom-3 left-1/2 -translate-x-1/2 z-30
                     text-white/80 hover:text-white
                     focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70
                     rounded-full p-2 cursor-pointer"
        >
          <svg
            className="w-5 h-5 animate-bounce"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>

        <div id="hero-end" className="absolute bottom-0 left-0 w-full h-px" />
      </section>

      {/* ===== TÍTULO INTERMEDIO ===== */}
      <div className="w-full bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-6">
          <div className="pt-10 pb-10 md:pt-10 md:pb-10 text-center">
            <h2 className="title-onepalm text-md md:text-4xl text-gray-900">Summer Season 26’</h2>
            <div className="mt-1 flex justify-center">
              <span className="inline-block h-[1px] w-24 bg-gray-900/90" />
            </div>
          </div>
        </div>
      </div>

      {/* Sección productos — con id para el scroll */}
      <section id="productos" className="bg-white pb-6 scroll-mt-[12.5rem] md:scroll-mt-40">
        {/* --- MOBILE --- */}
        <div className="block lg:hidden w-full">
          <div
            ref={mobileTrackRef}
            className="overflow-x-auto no-scrollbar flex gap-4 px-4 scroll-smooth snap-x snap-mandatory"
          >
            {mallas.map((m) => {
              const precioOriginalFmt = formatPrice(m.precio);

              const precio30 = precio30Off(m.precio);
              const precio30Fmt = formatPrice(precio30);

              const precioTransf = precioTransfer(precio30);
              const precioTransfFmt = formatPrice(precioTransf);
              const cuotaFmt = formatPrice(precio30 / 3);
              return (
                <Link key={m.id} to={`/producto/${m.id}`} className="group flex-none w-[70%] snap-center shrink-0">
                  <div className="aspect-[4/5] overflow-hidden">
                    <img
                      src={m.img}
                      alt={m.nombre}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>

                  <div className="mt-3 text-center items-baseline justify-between">
                    <span className="nav-onepalm text-sm text-gray-900">{m.nombre}</span>
                  </div>

                  <div className="flex justify-center items-baseline gap-2 mt-1">
                    <span className="text-xs text-gray-500 line-through proba">${precioOriginalFmt}</span>
                    <span className="text-xs font-semibold text-black proba">${precio30Fmt}</span>
                    <span className="text-[10px] font-semibold text-red-600 proba">30% OFF</span>
                  </div>
                  <div className="text-xs mt-1 text-center">
                    <span className="inline-flex items-baseline gap-1 text-green-700 whitespace-nowrap">
                      <span className="text-xs proba leading-none">${precioTransfFmt}</span>
                      <span className="text-[9px] leading-none prueba">en Transferencia</span>
                    </span>
                  </div>
                  <div className="text-[10px] lg:text-sm text-black-900 mt-1 items-center gap-1.5 prueba text-center">
                    <span>3 cuotas sin interés de </span>
                    <span className="inline-flex items-center proba gap-1 font-semibold">
                      ${cuotaFmt} <FaCreditCard className="w-3 h-3" aria-hidden="true" />
                    </span>
                  </div>

                  {/* ⬅️ NUEVO: Botón COMPRAR (igual que en Productos) */}
                  <div className="mt-3 flex justify-center">
                    <button
                      onClick={(e) => handleComprarListado(e, m)}
                      className="proba text-[9px] sm:w-auto border border-transparent
                     bg-gray-600 disabled:bg-gray-300 disabled:text-gray-500
                      disabled:cursor-not-allowed text-white px-4 py-1 shadow-sm
                      hover:bg-white hover:text-gray-700 hover:border-black active:scale-95 transition"
                      aria-label={`Comprar ${m.nombre}`}
                      title="Comprar"
                      type="button"
                    >
                      Comprar
                    </button>
                  </div>
                </Link>
              );
            })}
          </div>

          {/* sprite + flechas mobile */}
          <svg aria-hidden="true" className="absolute w-0 h-0 overflow-hidden">
            <defs>
              <symbol id="arrow-long" viewBox="0 0 24 24">
                <path
                  d="M3 12h16m0 0-5-5m5 5-5 5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </symbol>
            </defs>
          </svg>
          <div className="flex items-center justify-between px-3 mt-5 select-none">
            <svg
              viewBox="0 0 24 24"
              aria-label="Anterior"
              role="img"
              onClick={canPrev ? () => scrollByCard("prev") : undefined}
              className={`${
                canPrev ? "text-gray-900 cursor-pointer" : "text-gray-900 pointer-events-none"
              } w-[30px] h-[30px] transition-transform hover:scale-105 active:scale-95 rotate-180`}
            >
              <use href="#arrow-long" xlinkHref="#arrow-long" />
            </svg>
            <svg
              viewBox="0 0 24 24"
              aria-label="Siguiente"
              role="img"
              onClick={canNext ? () => scrollByCard("next") : undefined}
              className={`${
                canNext ? "text-gray-900 cursor-pointer" : "text-gray-900 pointer-events-none"
              } w-[30px] h-[30px] transition-transform hover:scale-105 active:scale-95`}
            >
              <use href="#arrow-long" xlinkHref="#arrow-long" />
            </svg>
          </div>
        </div>

        {/* --- DESKTOP/TABLET --- */}
        <div
          className="hidden lg:grid mx-auto 
                     px-8 2xl:px-12
                     max-w-[1600px] xl:max-w-[1700px] 2xl:max-w-[1800px]
                     grid-cols-4 gap-8"
        >
          {mallas.map((m) => {
            const precioOriginalFmt = formatPrice(m.precio);

            const precio30 = precio30Off(m.precio);
            const precio30Fmt = formatPrice(precio30);

            const precioTransf = precioTransfer(precio30);
            const precioTransfFmt = formatPrice(precioTransf);
            const cuotaFmt = formatPrice(precio30 / 3);
            return (
              <Link key={m.id} to={`/producto/${m.id}`} className="group block">
                <div className="aspect-[4/5] overflow-hidden ">
                  <img
                    src={m.img}
                    alt={m.nombre}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>

                <div className="mt-4 items-baseline justify-between text-center">
                  <span className="nav-onepalm font-semibold text-md text-gray-900">{m.nombre}</span>
                </div>

                <div className="mt-2 text-center">
                  <div className="flex justify-center items-baseline gap-2">
                    <span className="text-xs text-gray-500 line-through proba">${precioOriginalFmt}</span>
                    <span className="text-xs font-semibold text-black proba">${precio30Fmt}</span>
                    <span className="text-[10px] font-semibold text-red-600 proba">30% OFF</span>
                  </div>
                  <div className="text-xs mt-1 text-center">
                    <span className="inline-flex items-baseline gap-1 text-green-700 prueba whitespace-nowrap">
                      <span className="text-xs font-extrabold leading-none proba">
                        ${precioTransfFmt}
                      </span>
                      <span className="text-[8px] leading-none">en Transferencia</span>
                    </span>
                  </div>
                  <div className="text-[12px] lg:text-xs text-black-900 mt-1 items-center gap-1.5 font-medium">
                    <span>3 cuotas sin interés de </span>
                    <span className="inline-flex items-center gap-1 font-semibold proba text-center">
                      ${cuotaFmt}
                      <FaCreditCard className="w-3 h-3" aria-hidden="true" />
                    </span>
                  </div>
                </div>

                {/* ⬅️ NUEVO: Botón COMPRAR (igual que en Productos) */}
                <div className="mt-3 flex justify-center">
                  <button
                    onClick={(e) => handleComprarListado(e, m)}
                    className="text-[11px] h-8 px-3 inline-flex items-center justify-center
                               border border-black bg-white text-gray-900
                               hover:bg-gray-900 hover:text-white transition rounded-none"
                    aria-label={`Comprar ${m.nombre}`}
                    title="Comprar"
                    type="button"
                  >
                    Comprar
                  </button>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      {/* Carteles finales (sin cambios) */}
      <div className="hidden lg:block mx-auto w-full px-8 2xl:px-12 mt-16">
        <div
          className="mx-auto 
                        max-w-[1600px] xl:max-w-[1700px] 2xl:max-w-[1800px]
                        bg-[#ffae00] text-gray-900 text-center py-12"
        >
          <h3 className="text-2xl xl:text-3xl nav-onepalm mb-3">Para quienes persiguen el verano</h3>
          <p className="max-w-5xl mx-auto pd-onepalm text-base xl:text-lg leading-relaxed">
            Donde hay amigos, hay verano. Y donde hay verano, el tiempo afloja y se estira. Vivimos la vida como se supone que debe vivirse…
            con una sonrisa en la cara, rodeados de buena gente y siempre yendo por más.
            Esto es <span className="font-semibold">WetSoul</span>.
          </p>
        </div>
      </div>

      <div className="block lg:hidden bg-[#ffae00] text-gray-900 py-8 px-6 text-center mt-16 max-w-[1200px] mx-auto">
        <h3 className="text-md md:text-3xl nav-onepalm mb-2">Para quienes persiguen el verano</h3>
        <p className="max-w-4xl mx-auto pd-onepalm md:text-lg leading-relaxed">
                    Donde hay amigos, hay verano. Y donde hay verano, el tiempo afloja y se estira. Vivimos la vida como se supone que debe vivirse…
          con una sonrisa en la cara, rodeados de buena gente y siempre yendo por más.
           <p>~<span className="font-semibold"> WetSoul </span> ~</p>
        </p>
      </div>
    </>
  );
}

